import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, } from '@angular/forms';
import { ngxCmDropdownDataModel } from '../../models';
import { HttpClient } from '@angular/common/http';
import { ArrayMapPipe } from '../../ngx-cm-filters/array-map.pipe';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropdownComponent),
  multi: true,
};

@Component({
  selector: 'ngx-cm-dropdown',
  templateUrl: 'dropdown.component.html',
  styleUrls: ['dropdown.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR]
})
export class DropdownComponent implements OnInit, ControlValueAccessor {
  // Inputs
  @Input()
  Options: Array<ngxCmDropdownDataModel> = [];
  @Input()
  Ajax = false;
  @Input()
  AjaxURL: string;
  @Input()
  IdProperty: string;
  @Input()
  NameProperty: string;
  OptionsViewModel: Array<ngxCmDropdownDataModel> = [];

  onChange = Function;
  currentValue;
  showOptions;
  loading;
  searchControl = new FormControl();

  constructor(
    private _http: HttpClient
  ) { }

  ngOnInit() {
    // bind to input options if ajax is not required
    if (!this.Ajax) {
      // transform result stored in local variable using supplied transformer function
      // if not supplied, store unintect result
      let Options = this.IdProperty && this.NameProperty
        ? new ArrayMapPipe().transform(this.Options, { id: this.IdProperty, name: this.NameProperty })
        : this.Options;
      this.OptionsViewModel = Options;
    }

    // load data from ajaxUrl when search field value changes
    this.searchControl.valueChanges.subscribe(query => {
      try {
        if (this.Ajax) {
          // enable loader
          this.loading = true;

          // throw error if ajaxUrl is not supplied
          if (!this.AjaxURL) {
            console.error('Please provide ajax url that provides data of type ngxCmDropdownDataModel as a source.');
            return;
          }

          // call ajaxUrl api
          this._http.get(this.AjaxURL).subscribe((result: any) => {
            // check if search query is not empty or null
            if (query) {

              // store result in local variable
              let Options: Array<ngxCmDropdownDataModel>;
              try {

                // transform result stored in local variable using supplied transformer function
                // if not supplied, store unintect result
                Options = this.IdProperty && this.NameProperty
                  ? new ArrayMapPipe().transform(result, { id: this.IdProperty, name: this.NameProperty })
                  : result;

                // filter local options variable and store it in view model
                this.OptionsViewModel = Options.filter(o => {
                  if (o.name.toString().toLowerCase().indexOf(query) !== -1) {
                    return o;
                  }
                });
              } catch (ex) {

                // if thrown error, its highly likely that api result is not in expected format
                console.error('Api returned an invalid array of datatype. Expected array of type ngxCmDropdownDataModel and got any instead.');
                console.warn('If your Api returns an array of other type, Supply a transformer function that converts your api response to ngxCmDropdownDataModel and returns it. Check official plugin website for more information.')
              }
            } else {
              // don't show data if search query is empty or null
              this.OptionsViewModel = [];
            }
          });
        } else {
          let Options = this.IdProperty && this.NameProperty
            ? new ArrayMapPipe().transform(this.Options, { id: this.IdProperty, name: this.NameProperty })
            : this.Options;
          // if ajax is not required. filter supplied options using search query
          this.OptionsViewModel = Options.filter(o => {
            if (o.name.toLowerCase().indexOf(query) !== -1) {
              return o;
            }
          });
        }
      } catch (ex) {
        console.error(ex);
      }

      // hide loader after 1 second to avoid loader flickering
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    });
  }

  writeValue(value: any): void {
    this.onChange(value);

    // update local view
    this.currentValue = value;
    this.showOptions = false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onChange = fn;
  }

  setDisabledState(isDisabled: boolean): void { }
}
